import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    placeholder: {
      position: "relative",
      backgroundColor: theme.palette.placeholder,
      height: "100%",
    },
  }),
  { name: "Placeholder" },
);
